import { Lesson } from 'src/store/models/timetable/index.js'

const getSubject = l => {
  if (l?.meta?.displayname) {
    return { shortcut: String(l.meta.shortname || l.meta.displayname), name: String(l.meta.displayname) }
  }

  if (l?.course?.subject) {
    return l.course && l.course.subject
  }
}

const TimetableCellDetails = {
  methods: {
    getFormattedData (lesson, selectedEntity = null) {
      if (!lesson) return []

      const substitutedLessons = lesson.substituted_lessons || []
      const substitutedTargetLessons = lesson.substituted_target_lessons || []

      const lessons = [
        ...substitutedTargetLessons.map(sub => this.getRightSubstitution(lesson, sub, null)),
        ...substitutedLessons.map(sub => this.getRightSubstitution(lesson, null, sub))
      ]

      return (lessons.length ? lessons : [this.getRightSubstitution(lesson)])
        .map(({ oldLesson, newLesson }) => this.getFormatDataFromLessons(oldLesson, newLesson, selectedEntity))
    },

    getFormatDataFromLessons (oldLesson, newLesson, selectedEntity = null) {
      const formattedData = this.getFormattedEntitiesBySubstitution(oldLesson, newLesson)
      const selectedEntityData = (selectedEntity && formattedData[selectedEntity.entity]) || []

      return {
        ...formattedData,
        kind: newLesson?.meta.displayname_kind,
        comment: newLesson?.comment,
        description: newLesson?.meta?.moved_comment,
        id: newLesson?.id || oldLesson.id,
        selectedEntityMissing: selectedEntityData.find(el => el.entity.id === selectedEntity.id && el.class === 'missing')
      }
    },
    getFormattedEntitiesBySubstitution (oldLesson, newLesson) {
      const oL = oldLesson || newLesson
      const nL = newLesson || {}

      const newSubject = (nL.kind !== 'CANCLED' && getSubject(nL))

      const oldSubject = getSubject(oL)

      return ['teachers', 'grades', 'bookables', 'subject'].reduce((acc, key) => {
        const isSubject = key === 'subject'

        const oldIdsRaw = isSubject && oldSubject ? [oldSubject] : oL[key] || []

        // new lesson should be shown with new entities
        const oldIds = nL.kind === 'MOVED_TO' || nL.kind === 'ADDITIONAL' ? [] : oldIdsRaw
        const newIds = isSubject && newSubject ? [newSubject] : nL[key] || []

        const noMissingLessons = !nL.kind // || nL.kind === 'MOVED'// || substitution.kind !== 'CANCLED'

        return {
          ...acc,
          [isSubject ? 'subjects' : key]: [
            ...oldIds.map((entity) => ({
              entity,
              class: noMissingLessons || newIds.find(el => el.shortcut === entity.shortcut) ? 'normal' : 'missing'
            })),
            ...newIds.map((entity) => ({
              entity,
              class: oldIds.find(el => el.shortcut === entity.shortcut) ? null : 'additional'
            }))
          ].filter(el => el.class)
            .sort(el => el.class === 'additional' ? -1 : el.class === 'normal' ? -1 : 1)
        }
      }, {})
    },
    getRightSubstitution (lesson, targetLesson = null, substitutedLesson = null) {
      if (targetLesson && targetLesson.kind === 'MOVED_TO') {
        return {
          oldLesson: new Lesson({
            ...lesson,
            description: this.calcMovedText(lesson)
          }),
          newLesson: new Lesson({
            kind: 'MOVED_FROM',
            meta: {
              displayname: null,
              displayname_kind: 'verschoben von'
            },
            description: this.calcMovedText(targetLesson)
          })
        }
      }

      if (substitutedLesson && lesson.kind === 'MOVED_TO') {
        return {
          oldLesson: substitutedLesson,
          newLesson: new Lesson({
            ...lesson,
            // todo: get right old date to show text
            description: this.calcMovedText(substitutedLesson, lesson, false)
          })
        }
      }

      if (substitutedLesson) {
        return {
          oldLesson: substitutedLesson,
          newLesson: lesson
        }
      }

      if (['ADDITIONAL', 'EVENT', 'MESSAGE'].includes(lesson.kind)) {
        return {
          oldLesson: null,
          newLesson: lesson
        }
      }

      return {
        oldLesson: lesson,
        newLesson: null
      }
    },
    calcMovedText (mirrorSubstitution, originalSubstitution = null, movedFrom = true) {
      if (!mirrorSubstitution) return null

      const directionText = movedFrom ? 'auf' : 'von'

      // find old_lesson with pivot
      const pivot = originalSubstitution && mirrorSubstitution.substituted_pivot.find(pivot => pivot.target_id === originalSubstitution.lesson_id)

      const moveToDate = this.$moment.unix((pivot && pivot.lesson_date) || mirrorSubstitution.dates[0])
      const moveToTime = this.$moment.unix(mirrorSubstitution.time_begins_at)
      return `Die Stunde wurde ${directionText} '${this.$dateFormat.weekday_date_month_year(moveToDate)} ${this.$dateFormat.hour_minute(moveToTime)}' verlegt`
    }
  }
}

export default TimetableCellDetails
